import { IAppState } from '../../../AppModulesWrapper';

import { selectOfferGuid } from '../offer';

export const selectAnalyticsFormId = (state: IAppState): string => {
  const offerGuid = selectOfferGuid(state);
  // @TODO после полной раскатки новой ФП в offerGuid будет лежать актуальный guid формы
  // нужно будет удалить поле formId из объекта объявки
  const newAddFormOfferGuid = state.servicePickerWidget.offer.formId;

  return newAddFormOfferGuid || offerGuid;
};
